// libs
import React from 'react';
import Routes from '@/constants/Routes';
import { useNavigate } from 'react-router-dom';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsFontVariants, DlsColorTokens } from '@/constants/DLSTokens';
// icons
import { IconSearch } from '@/constants/icons/svg';
// styles
import styles from './FindCampaignButton.module.scss';
const FindCampaignButton = () => {
    const navigate = useNavigate();
    const handleFindCampaignClick = () => {
        navigate(Routes.INSTAMART.CAMPAIGN_LIST, { preventScrollReset: true });
    };
    return (React.createElement("div", { className: styles.container, role: "button", onClick: handleFindCampaignClick },
        React.createElement(IconSearch, { fillColor: "#F15700" }),
        React.createElement(Text, { variant: DlsFontVariants.button_Text_BT3, color: DlsColorTokens.primary }, "Find a Campaign")));
};
export default FindCampaignButton;
